<script>
export default {
  name: 'Odd',
  props: {
    pick: {
      required: true
    },
    specifier: {
      required: true
    },
    away_team: {
      required: true
    },
    home_team: {
      required: true
    },
    date: {
      required: true
    },
    market_name: {
      required: true
    },
    match_id: {
      required: true
    },
    market_id: {
      required: true
    },
    market_status: {
      required: true
    },
    status: {
      required: true
    },
    status_name: {
      required: true
    },
    producer_id: {
      required: true
    },
    producer_status: {
      required: true
    },
    game_id: {
      required: true
    },
    active: {
      required: false
    },
    sport_id: {
      required: false
    },
  },
  data() {
    return {
      isSelected: false,
      id: ''
    };
  },
  mounted() {
    this.id = this.getOddID(
      this.match_id,
      this.market_id,
      this.pick.outcome_id.replace(/[^a-zA-Z0-9]/g, ''),
      this.specifier.replace(/[^a-zA-Z0-9]/g, ''),
      this.boosted ? 'boosted' : 'odd'
    );

    let selectedOdd = null;
    try {
      selectedOdd = JSON.parse(localStorage.getItem('betslip'));
    } catch (e) {
      console.error('Error parsing betslip from localStorage', e);
    }

    if (selectedOdd && selectedOdd.picks) {
      const bets = selectedOdd.picks;

      const onePick = Object.values(bets).some(pick => {
        // const cleanSpecifier = pick.specifier.replace(/[^a-zA-Z0-9]/g, '');
        const cleanSpecifier = (pick.specifier || '').replace(/[^a-zA-Z0-9]/g, '');
        const cleanOutcomeId = pick.outcome_id.replace(/[^a-zA-Z0-9]/g, '');
        const generatedOddID = this.getOddID(
          pick.match_id,
          pick.market_id,
          cleanOutcomeId,
          cleanSpecifier,
          pick.boosted ? 'boosted' : 'odd'
        );
        return generatedOddID === this.id;
      });

      if (onePick) {
        this.isSelected = true;
      }
    }
  },
  computed: {
    isVisible() {
      if (parseInt(this.producer_id) === 1 && parseInt(this.producer_status) === 0) {
        return false;
      }

      return !(parseInt(this.market_status) !== 0 || parseInt(this.active) === 0);
    },
    capitalizedOutcomeName() {
      if (this.pick.alias) {
        return this.pick.alias.charAt(0).toUpperCase() + this.pick.alias.slice(1);
      }
      return '';
    },
  },
}
</script>

<template>
  <button
    :id="id"
    type="button"
    class="btn-maybets"
    :disabled="!isVisible || pick.odds < 1.01"
    :class="{ 'no-click': !isVisible || pick.odds < 1.01, 'selected-odds': isSelected }"
    @click="addPick(
      match_id, date, market_name, market_id, home_team,
      away_team, pick, producer_id, producer_status, status_name, market_status, game_id,
      status, specifier, category_id, country, tournament_id, tournament
    )">
<!--    @click="(isVisible && pick.odds >= 1.01) ? addPick(match_id, date, market_name, market_id, home_team, away_team, pick, producer_id, producer_status, status_name, market_status, game_id, status, specifier, category_id, country, tournament_id, tournament) : null">-->
    <span class="market-option">{{ capitalizedOutcomeName }}</span>
    <span v-if="!isVisible || pick.odds < 1.01" class="odds">
      <i class="bi bi-lock-fill"></i>
    </span>
    <span v-else class="odds">
      <span v-if="pick.probability > 0.30 && pick.odds > 1.20 && pick.odds < 1.99
                  && !(pick.probability >= 0.40 && pick.probability <= 0.60 && pick.odds >= 1.50 && pick.odds <= 1.62)" class="odds">
        <i class="bi bi-fire text-danger"></i>
      </span>
      <span v-if="pick.probability >= 0.30 && pick.probability <= 0.60 && pick.odds >= 1.50 && pick.odds <= 1.62" class="odds">
        <i class="bi bi-lightning-fill" style="color: blue"></i>
      </span>
      {{ pick.odds.toFixed(2) }}
    </span>
  </button>
</template>

<style scoped>
.odds i {
  font-size: .9rem;
}

/* Small screens */
@media (max-width: 450px) {
  .odds i {
    font-size: .65rem;
  }
}

/* Extra small screens */
@media (max-width: 380px) {
  .odds i {
    font-size: .55rem;
  }
}

/* Extra small screens */
@media (max-width: 360px) {
  .odds i {
    display: none;
  }
}
</style>